"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceMediaQueryBuilder = void 0;
const devicesMeasures_1 = require("../device/devicesMeasures");
class DeviceMediaQueryBuilder {
    constructor(deviceMeasure = devicesMeasures_1.DEVICE_MEASURE) {
        this.deviceMeasure = deviceMeasure;
    }
    getMinWidthMediaQuery(size) {
        return `(min-width:${size}px)`;
    }
    getMaxWidthMediaQuery(size) {
        return `(max-width:${size}px)`;
    }
    getWidthBetweenMediaQuery(min, max) {
        return `(min-width:${min}px) and (max-width:${max}px)`;
    }
    getDesktopMediaQuery() {
        return this.getMinWidthMediaQuery(this.deviceMeasure.desktop.width.min);
    }
    getTabletMediaQuery() {
        return this.getWidthBetweenMediaQuery(this.deviceMeasure.tablet.width.min, this.deviceMeasure.tablet.width.max);
    }
    getMobileMediaQuery() {
        return this.getMaxWidthMediaQuery(this.deviceMeasure.mobile.width.max);
    }
    getMobileAndTabletMediaQuery() {
        return this.getMaxWidthMediaQuery(this.deviceMeasure.tablet.width.max);
    }
    getTabletAndDesktopMediaQuery() {
        return this.getMinWidthMediaQuery(this.deviceMeasure.tablet.width.min);
    }
}
exports.DeviceMediaQueryBuilder = DeviceMediaQueryBuilder;
//# sourceMappingURL=DeviceMediaQueryBuilder.js.map